import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { ContactSpecialistComponent } from '@app/components/contact-specialist/contact-specialist.component';
import { MatButtonModule } from '@angular/material/button';
import { DatePipe } from '@angular/common';
import { MortgageInterface } from '@app/interfaces/mortgage.interface';

@Component({
    selector: 'app-invalid-modelations-dialog',
    templateUrl: './invalid-modelations-dialog.component.html',
    styleUrls: ['./invalid-modelations-dialog.component.scss'],
    imports: [MatDialogModule, MatIconModule, ContactSpecialistComponent, MatButtonModule, DatePipe],
})
export class InvalidModelationsDialogComponent {
    dialogRef = inject<MatDialogRef<InvalidModelationsDialogComponent>>(MatDialogRef);
    mortgage = inject<MortgageInterface>(MAT_DIALOG_DATA);
}
